$(window).load(function () {
  const hash = window.location.hash;
  console.log('test');

  if (hash.includes('#product_')) {
      let $productEl = $(hash);
      const productId = hash.split('_')[1];

      if ($productEl.length === 0) {
        $productEl = $(`.post-${productId}`);

        if ($productEl.length > 0) {
          goToSpecificDiet($productEl, true);
        }
      } else {
        goToSpecificDiet($productEl);
      }
  }

  function goToSpecificDiet($productEl, openPopup = false) {
    $('html, body').animate({
        scrollTop: $productEl.offset().top - 200
    }, 1500, function() {
      if (openPopup) {
        $productEl.children(":first").trigger('click');
      }
    });
  };
});


// WEBPACK FOOTER //
// ./assets/js/handle-product-url.js